import {EventEmitter, Injectable} from '@angular/core';
import {FormService} from './FormService';
import {ILoadedBranch, SystemService} from './SystemService';
import {first} from 'rxjs';
import {HttpResponse} from '@angular/common/http';
import {BcGqlService, IGQLResponse} from '@betterchains/bc-gql';
import {AppDialogService} from './AppDialogService';
import {MessageService} from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class AssignmentService {

  public formId: number = 0
  public currentChainId: number|null = null
  public currentBranchId: number|null = null

  private assignments: { chain_id: number, branch_id: number }[] = []

  public OnChainAssigned: EventEmitter<number> = new EventEmitter<number>()
  public OnChainChanged: EventEmitter<number> = new EventEmitter<number>()
  public OnBranchAssigned: EventEmitter<number> = new EventEmitter<number>()
  public OnBranchChanged: EventEmitter<number> = new EventEmitter<number>()
  public OnBranchUnAssigned: EventEmitter<number> = new EventEmitter<number>()

  constructor(
    private sysvc: SystemService,
    private fsvc: FormService,
    private gql: BcGqlService,
    private dialogs: AppDialogService,
    private toast: MessageService
  ) {
  }

  public GetCurrentChainId() {
    const id = Number(this.currentChainId)
    return isNaN(id) ? 0 : id
  }

  public GetCurrentBranchId() {
    const id = Number(this.currentBranchId)
    return isNaN(id) ? 0 : id
  }

  public IsChainAssigned() {
    const a = this.assignments.find((a: any) => a.chain_id === Number(this.currentChainId))
    return (typeof a != "undefined")
  }

  public IsBranchAssigned() {
    const a = this.assignments.find((a: any) => {
        return a.chain_id === this.GetCurrentChainId()
          && a.branch_id === this.GetCurrentBranchId()
      }
    )
    return (typeof a != "undefined")
  }

  public AddAssignment(chain_id: number, branch_id: number) {
    const a = this.assignments.find((a: any) => {
        return a.chain_id === Number(chain_id) && a.branch_id === Number(branch_id)
      }
    )
    if (typeof a == "undefined") {
      this.assignments.push({chain_id, branch_id})
      this.currentBranchId = branch_id;
      this.OnBranchChanged.emit(this.currentBranchId)
    }
  }

  public RemoveAssignment(chain_id: number, branch_id: number) {
    const ai = this.assignments.findIndex((a: any) => {
        return a.chain_id === Number(chain_id) && a.branch_id === Number(branch_id)
      }
    )
    if (ai >= 0) {
      this.assignments.splice(ai, 1)
      this.currentBranchId = null;
      this.OnBranchChanged.emit(this.currentBranchId)
    }
  }

  public CheckAssignmentCreated() {
    this.gql.query(
      //language=GraphQL
      `
        query checkBranchAssignment($form_id: Int!) {
          forms {
            form(id: $form_id) {
              branches {
                branch_id
                chain_id
              }
            }
          }
        }
      `, {form_id: Number(this.formId)})
      .pipe(first())
      .subscribe({
        next: (res: HttpResponse<IGQLResponse<{
          forms: { form: { branches: { branch_id: number, chain_id: number }[] } }
        }>>) => {
          res.body.data.forms.form.branches.forEach((b: { branch_id: number, chain_id: number }) => {
            this.AddAssignment(b.chain_id, b.branch_id)
          })
        }
      })
  }

  UnAssignChain() {
    this.dialogs.Confirm(
      "Unassign Chain",
      "Are you sure you want to unassign this form from the selected Chain?"
    ).onClose.pipe(first()).subscribe((result: boolean) => {
      if (result) {
        let isUnAssigned = false;

        //Positions
        if (typeof this.fsvc.form_json == "undefined") {
          this.dialogs.Alert("Error", "Form is empty.");
          return false;
        }

        this.fsvc.form_json.assignedChains.forEach((assignedChainModel: any, key: number) => {
          if (typeof assignedChainModel != "undefined"
            && Number(assignedChainModel.chain_id) === this.GetCurrentChainId()
          ) {
            this.fsvc.form_json.assignedChains.splice(key, 1);
          }
        });

        this.currentChainId = null;
        this.currentBranchId = null;
        isUnAssigned = true;
        if(isUnAssigned) {
          this.toast.add({
            severity: 'success',
            summary: 'Success',
            detail: 'The Chain has been successfully unassigned!',
          });
        } else {
          this.toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'The Chain has not been successfully unassigned!',
          });
        }
      }
    })
  }

  ReloadChainBranches() {
    this.cchain.branchesList = [];
    this.currentBranchId = null;

    if (this.currentChainId != null && this.currentChainId) {
      this.sysvc.GetBranches(this.currentChainId).then(branches => this.cchain.branchesList = branches)
      this.sysvc.GetPositions(this.currentChainId).then()
    }
  }

  cchain: IAssignmentServiceChain = {
    branchesList: []
  }

  Init(formId: number) {
    this.formId = formId;
    this.cchain.branchesList = [];
  }
}

export interface IAssignmentServiceChain {
  branchesList: ILoadedBranch[]
}
